import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useExamBoards = (country_id) => {
  const formData = new FormData();
  if (country_id) formData.set("country_id", country_id);

  return useQuery(
    ["examBoards", country_id],
    async () => {
      const { data } = await axiosPost("/api/cw/viewExamBoardFilter", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useExamBoards;
